// Priority-rating domain maps shared by the Prioritize attributes/table layout
// and the module's legend, widgets and countermeasures UI.

export const mapPriorityDescription: Record<string, string> = {
	HIGH: 'Priority 1',
	'MEDIUM-HIGH': 'Priority 2',
	MEDIUM: 'Priority 3',
	'LOW-MEDIUM': 'Priority 4',
	LOW: 'Priority 5',
	UNKNOWN: 'Not prioritized'
};

export const priorityDescriptionOrder = ['HIGH', 'MEDIUM-HIGH', 'MEDIUM', 'LOW-MEDIUM', 'LOW'];

export const mapNotPrioritizedReason: Record<string, string> = {
	oneway: 'Road is one-way or dual carriageway',
	lowspeed:
		'Speed limit or operating speed is below the prioritization threshold (refer to Prioritize whitepaper)',
	nocurves: 'Corridor has no curves',
	nocontext: 'All curves on the corridor are Class 4'
};
